import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import {
  ThemeProvider,
  createMuiTheme,
  responsiveFontSizes,
} from '@material-ui/core/styles';
import overrides from './overrides';
import green from '@material-ui/core/colors/green';

// Palettes
const PRIMARY_DEFAULT = '#213b83';
const SECONDARY_DEFAULT = green.main;

function MyThemeProvider(props) {
  const { theme_config, active_lang, lang_headers = {} } = props;

  const {
    backIconButtonText,
    nextIconButtonText,
    clearText,
    closeText,
    loadingText,
    noOptionsText,
    openText,
    openPlacesAutocompleteText,
    placesSearchPlaceholderText,
    noOptionsPlacesAutocompleteText,
    geolocationText,
    siteSearchLinkText,
    searchText,
    resultsText,
    resultsCountText,
    noSitesFoundText,
    countrySitesHeadingText,
    countryLinkText,
    countryPlaceholderText,
    addressText,
    siteText,
    prescreenButtonText,
    milesText,
    prescreenText,
    statusText,
    distanceText,
    mapViewText,
    listMapViewText,
    listViewText,
    siteLanguageSingleText,
    siteLanguageMultipleText,
  } = lang_headers;

  const translation = useMemo(() => {
    return {
      MuiAutocomplete: {
        clearText,
        closeText,
        loadingText,
        noOptionsText,
        openText,
      },
      MuiAlert: { closeText },
      PlacesAutocomplete: {
        placeholderText: placesSearchPlaceholderText,
        geolocationText,
        openText: openPlacesAutocompleteText,
        noOptionsText: noOptionsPlacesAutocompleteText,
      },
      SiteSearch: {
        siteSearchLinkText,
        searchButtonLabel: searchText,
      },
      SearchDetails: {
        headingText: resultsText,
        resultsCountText,
        loadingText,
        unitText: milesText,
        noResults: noSitesFoundText,
        prescreenText,
        addressText,
        statusText,
        distanceText,
        backIconButtonText,
        nextIconButtonText,
        mapViewText,
        listMapViewText,
        listViewText,
        siteLanguageSingleText,
        siteLanguageMultipleText,
      },
      CountrySearch: {
        countrySitesHeadingText,
        countryLinkText,
        placeholder: countryPlaceholderText,
      },
      CountryDetails: {
        addressText,
        siteText,
        prescreenButtonText,
      },
    };
  }, []);

  const theme = useMemo(() => {
    const {
      primary = PRIMARY_DEFAULT,
      secondary = SECONDARY_DEFAULT,
      tertiary = 'rgba(0, 0, 0, 0.87)',
    } = theme_config || {};
    let themeConfig = createMuiTheme(
      {
        palette: {
          primary: { main: primary },
          secondary: { main: secondary },
          text: {
            primary: tertiary,
          },
          background: {
            default: '#fff', // controls input color for now
          },
        },
        typography: {
          fontFamily: 'inherit',
          subtitle1: {
            fontWeight: 'bold',
            lineHeight: 'normal',
          },
        },
        props: {
          // Name of the component ⚛️
          MuiButtonBase: {
            // The properties to apply
            disableRipple: true, // No more ripple, on the whole application 💣!
          },
          // MuiTextField: {
          //   disableUnderline: true
          // },
        },
        overrides,
      },
      { props: translation },
    );
    return responsiveFontSizes(themeConfig);
  }, [translation, theme_config]);

  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
}

function mapStateToProps({ lang_headers, trial, theme_config }) {
  return {
    active_lang: trial.language,
    lang_headers: lang_headers,
    theme_config: theme_config,
  };
}

export default connect(mapStateToProps)(MyThemeProvider);
